module.exports = __webpack_public_path__ + "img/info-icon.3426ffc4.svg";